import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { withTheme } from "@emotion/react";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Bar } from "react-chartjs-2";

import { MoreVertical } from "react-feather";

import {
  Breadcrumbs as MuiBreadcrumbs,
  Button as MuiButton,
  Card as MuiCard,
  CardContent,
  Chip as MuiChip,
  Divider as MuiDivider,
  Grid as MuiGrid,
  Link,
  CardHeader,
  Typography as MuiTypography,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import { ListAlt as ListAltIcon } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import { spacing } from "@mui/system";
import useGift from "hooks/useGift";
import GridGiftActivated from "./GridGiftActivated";
// ----------------------------------------------------------------------
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Button = styled(MuiButton)(spacing);

const Card = styled(MuiCard)(spacing);

const Chip = styled(MuiChip)(spacing);

const Divider = styled(MuiDivider)(spacing);

const Grid = styled(MuiGrid)(spacing);

const Typography = styled(MuiTypography)(spacing);

// ----------------------------------------------------------------------

export default function GiftActivated() {
  const { downloadGiftActivatedCsv, gifts, giftsActivated, getGiftsActivated } =
    useGift();
  const [disabled, setDisabled] = useState(false);
  useEffect(() => {
    getGiftsActivated();
  }, []);
  return (
    <>
      <Helmet title="Catalogue des coupons cadeau" />
      <Grid justifyContent="space-between" container spacing={10}>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            Cadeaux activés
          </Typography>

          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} to="/app">
              Accueil
            </Link>
            <Typography>Cadeaux activés</Typography>
          </Breadcrumbs>
        </Grid>
        <Grid item>
          <Button
            variant="outlined"
            color="primary"
            disabled={disabled}
            onClick={async () => {
              setDisabled(true);
              try {
                await downloadGiftActivatedCsv();
              } catch (error) {
                console.error(error);
              }
              setDisabled(false);
            }}
          >
            <ListAltIcon />
            Télécharger la liste
          </Button>
        </Grid>
      </Grid>
      <Divider my={6} />
      <Grid container spacing={6}>
        <Grid item xs={12}>
          {giftsActivated && <GridGiftActivated items={giftsActivated} />}
        </Grid>
      </Grid>
    </>
  );
}
